import { createRevisionClassResource, RevisionActions } from "../../revision";
import { NameResourceItem } from "../NameResourceItem";
import { RevisionItem } from "../RevisionItem";
import {
  apiField,
  constructFromApiData,
  getApiPostData,
  itemApiField,
  itemArrayApiField,
  getDiff,
  revisionItemApiField,
  decimalApiField,
} from "../ResourceItemMetadata";
import { ResourceItem, IncompleteResourceItem } from "../ResourceItem";
import { Resource } from "../../resource";
import { CsvActions, createCsvResource } from "../../csvList";
import { createFullClassResource } from "../../fullResource";
import Decimal from "decimal.js";
import MegaraxClient from "../../megaraxClient";
import { getDumpAction } from "../../dump";

export class ProductGroup extends NameResourceItem {}
export class ObiektZastosowania extends NameResourceItem {}
export class CzescBudynku extends NameResourceItem {}
export class Narzedzie extends NameResourceItem {}
export class Rozpuszczalnik extends NameResourceItem {}
export class RodzajOpakowania extends NameResourceItem {}
export class Podloze extends NameResourceItem {}

export class Produkt extends RevisionItem {
  @apiField()
  name: string = "";

  @apiField()
  fullName: string = "";
  @revisionItemApiField()
  receptura: IncompleteResourceItem | null = null;
  @itemApiField(ProductGroup)
  productGroup: ProductGroup | null = null;

  @apiField()
  dopuszczonyDoProdukcji: boolean = false;
  @apiField()
  wZakresieProdukcji: boolean = false;
  @apiField()
  wTrakcieBadan: boolean = false;

  @apiField()
  opis: string = "";
  @itemArrayApiField(ObiektZastosowania)
  obiektZastosowania: ObiektZastosowania[] = [];
  @itemArrayApiField(CzescBudynku)
  czescBudynku: CzescBudynku[] = [];
  @itemArrayApiField(Podloze)
  podloze: Podloze[] = [];
  @apiField()
  wnetrze: boolean = false;
  @apiField()
  zewnetrze: boolean = false;
  @apiField()
  podWoda: boolean = false;
  @apiField()
  przeciwwskazania: string = "";
  @apiField()
  wlasciwosciUzytkowe: string = "";

  @apiField()
  przygotowaniePodloza: string = "";
  @apiField()
  przygotowanieProduktu: string = "";
  @apiField()
  metodykaPracy: string = "";
  @itemArrayApiField(Narzedzie)
  narzedzia: Narzedzie[] = [];
  @itemArrayApiField(Rozpuszczalnik)
  czyszczenieNarzedzi: Rozpuszczalnik[] = [];
  @apiField()
  faq: string = "";

  @decimalApiField()
  gwarancjaTrwalosciYears: Decimal | null = null;
  @apiField()
  zdatnoscDoUzyciaMonths: number | null = null;
  @itemArrayApiField(RodzajOpakowania)
  dopuszczalneRodzajeOpakowan: RodzajOpakowania[] = [];
  @apiField()
  skladowanie: string = "";
  @apiField()
  nrCn: string = "";
  @apiField()
  nrPkwiu: string = "";

  @apiField({ readOnly: true })
  activeWyrobSet: ResourceItem[] | null = null;

  toString() {
    return this.id ? this.id.toString() : "Nowy produkt";
  }

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return { ...getApiPostData(this), ...super.getPostData() };
  }

  getDiff(other: this) {
    return getDiff(this, other);
  }
}

const produktDataDumpLabels = [
  { key: "name", header: "indeksProduktu" },
  { key: "fullName", header: "nazwaProduktu" },
  { key: "productGroupStr", header: "grupaProduktowa" },
  { key: "productGroupNumber", header: "nrGrupyProduktowej" },
  { key: "recepturaStr", header: "receptura" },
  { key: "dopuszczonyDoProdukcji", header: "dopuszczonyDoProdukcji" },
  { key: "wZakresieProdukcji", header: "wZakresieProdukcji" },
  { key: "wTrakcieBadan", header: "wTrakcieBadan" },
];

export const produktResource = (client: MegaraxClient) => ({
  ...createRevisionClassResource("plm/produkt/", Produkt)(client),
  dump: getDumpAction("plm/produkt/", produktDataDumpLabels)(client),
});

export const productGroupResource = createFullClassResource(
  "plm/productGroup/",
  ProductGroup,
);

export const obiektZastosowaniaResource = createFullClassResource(
  "plm/obiektZastosowania/",
  ObiektZastosowania,
);

export const czescBudynkuResource = createFullClassResource(
  "plm/czescBudynku/",
  CzescBudynku,
);

export const narzedzieResource = createFullClassResource(
  "plm/narzedzie/",
  Narzedzie,
);

export const rozpuszczalnikResource = createFullClassResource(
  "plm/rozpuszczalnik/",
  Rozpuszczalnik,
);

export const rodzajOpakowaniaResource = createFullClassResource(
  "plm/rodzajOpakowania/",
  RodzajOpakowania,
);

export const podlozeResource = createFullClassResource("plm/podloze/", Podloze);
